//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../AME/AME.AMEBaseBuilder.js";
import "../AME/AME.SelectINodeObjectList.js";
import "../AME/AME.SelectionBaseDefinitionBuilder.js";
import "../no/SelectObjectList.js";
let d=[[[0,"DrawingStandard",1,0],[0,"ImmediateCommit",1,0],[1,"SelectedObjects",0,"AME.SelectINodeObjectList",0],[0,"SymbolRepresentationType",1,0],[1,"SymbolSelection",0,"AME.SelectionBaseDefinitionBuilder",0]],[[["objTag","nAssignedSymbols"],"GetAssignedSymbols",{R_:{assignedSymbols:""}},1,0],[["symbolNameString"],"SetDefaultSymbol",{},1,0],[["inputObject"],"GetDefaultSymbol",{R_:{symbolNameString:''}},1,0],[[],"ResetDefaultSymbol",{},0,0],[["symbolNameString"],"AddAssignedSymbol",{},1,0],[["symbolNameString"],"RemoveAssignedSymbol",{},1,0]],[]];
SPLM.AME.Manage2dSymbolsBuilder = class extends SPLM.AME.AMEBaseBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.Manage2dSymbolsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.Manage2dSymbolsBuilder.SymbolRepresentationTypes = Object.freeze({
    "MultiLineSchematic" : "MultiLineSchematic", "SingleLineSchematic" : "SingleLineSchematic", "BusTopologyDiagram" : "BusTopologyDiagram", "PowerSupplyTopologyDiagram" : "PowerSupplyTopologyDiagram", "FluidicDiagram" : "FluidicDiagram", "Cabinet2d" : "Cabinet2d", "GenericSchematic" : "GenericSchematic"});

SPLM.AME.Manage2dSymbolsBuilder.SymbolDrawingStandard = Object.freeze({
    "Iec" : "Iec", "Ansi" : "Ansi", "NonStandard" : "NonStandard"});

export default SPLM;